import { create } from "zustand";

const useTeamprofileStore = create((set) => ({
  currentContentTab: {
    id: 1,
    name: "Highlights",
  },
  setCurrentContentTab: (value) => set({ currentContentTab: value }),
}));

export default useTeamprofileStore;
